﻿import $ from "jquery";
import { GuiListGeneric } from "../GuiListGeneric";
import { GuiFilterZeitraum } from "../GuiFilterZeitraum";
import { ChartConfiguration, ChartData, TooltipItem } from "../chart-setup";

export class GuiAuswertung extends GuiListGeneric {

    green5 = "#044135";
    green2 = "#0CAD8E";

    constructor(public override listName: string) {
        super(listName);
        $("#auswertungfilter").removeClass("d-none");

        new GuiFilterZeitraum();
    }

    protected override attachEvents() {
        super.attachEvents();

        $("#detailForm select").on("change", () => { this.resetResult(); });
        $("#detailForm input[type=date]").on("blur", () => { this.resetResult(); });
        $("#detailForm button.btn-date-remove").on("click", () => { this.resetResult(); });

        // Menü
        $("#btnAuswertungCreate").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.doAction(e); });
        $("#btnAuswertungSave").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.doAction(e); });
        $("#btnGotoAktionen").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickGotoAktionen(e));
        $("#btnRefresh").on("click", () => this.clickRefresh());


        // data-bs-toggle="tooltip" data-bs-html="true"
        $("div.erz-list [data-bs-title]").attr("data-bs-toggle", "tooltip").attr("data-bs-placement", "right").attr("data-bs-html", "true");

        if ($("div.auswertungergebnis").length === 1) {
            this.draw();
        }


    }



    protected draw() {
    }


    clickGotoAktionen(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickGotoAktionen");

        // Action ändern für anderen Endpunkt
        const action = $(e.currentTarget).data("action") as string;

        $("#detailForm").attr("action", action);
    }

    clickRefresh() {
        this.log("clickRefresh");

        // Bei ungültiger Eingabe (z.B. min/max am Datum) bricht der Browser das Absenden ab und zeigt
        // seine Meldung am Feld - dann nicht sperren, sonst liegt "Bitte warten" darüber und bleibt stehen.
        const form = document.getElementById("detailForm") as HTMLFormElement | null;
        if (form != null && !form.checkValidity()) {
            return;
        }

        this.lock();
    }

    resetResult() {
        $("#txtAktionAnzahl").text("Aktionen (?)");
        $("#btnGotoAktionen").attr("disabled", "disabled").removeClass("btn-success").addClass("btn-secondary").data("anzahl", "");
        $("#btnRefresh").removeClass("btn-secondary").addClass("btn-success");
        $("#btnExport").removeClass("btn-erz").addClass("btn-secondary").attr("disabled", "disabled").remove();
        $("#btnDrucken").remove();
        $("div.auswertungergebnis").hide();
    }

    protected override clickRow(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickRow");
        e.preventDefault();
        // Standard verhalten nicht anwenden. Kein Goto Detail
    }


    protected CreateLineConfig(data: ChartData): ChartConfiguration {
        const config: ChartConfiguration = {
            type: "line",
            data: data,

            options: {

                plugins: {
                    legend:
                    {
                        display: true,
                        align: "start",
                        position: "left",
                        labels: {
                            color: "#000000"
                        }
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
            }
        };
        return config;
    }

    /**
     * Kreisdiagramm (DEVCLR-305). Die Legende bleibt ausgeblendet - die Zuordnung leisten die
     * Farbquadrate der Tabelle daneben.
     * @param werteSindProzent true, wenn die Chart-Werte bereits die serverseitig berechneten
     *        Anteile sind; der Tooltip haengt dann nur das Prozentzeichen an. Bewusst NICHT
     *        clientseitig rechnen: der Server gleicht die Rundung auf 100 % aus, eine zweite
     *        Rechnung im Browser wuerde davon abweichen. false = Chart.js-Standardtooltip
     *        (Abfall-Kosten: Kosten koennen negativ sein, ein Anteil waere irrefuehrend).
     * @param responsive false nur dort, wo das Layout es bisher schon so hatte (Abfall-Kosten).
     */
    protected CreateDoughnutConfig(data: ChartData, werteSindProzent = true, responsive = true): ChartConfiguration {
        const config: ChartConfiguration = {
            type: "doughnut",
            data: data,

            options: {
                plugins: {
                    legend:
                    {
                        display: false,
                    },
                    tooltip: werteSindProzent ? {
                        callbacks: {
                            // Parametertyp kontextuell aus ChartConfiguration (generisch ueber alle
                            // Charttypen) - fuer die Auswertung intern auf "doughnut" eingeengt.
                            label: (toolTipItem => {
                                const item = toolTipItem as TooltipItem<"doughnut">;
                                return item.label + " " + item.formattedValue + "%";
                            })
                        }
                    } : {}
                },
                responsive: responsive,
                maintainAspectRatio: false
            }
        };
        return config;
    }
}
